import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Select } from "semantic-ui-react";

import "./SidePanel.scss";

import StoreAttributes from "./StoreAttributes";
import * as actions from "../../store/actions/actions";
import { reportTypes } from "../../store/reducers/reports";

const selectOptionPlaceholderText = "Select ...";
const selectOptionDefaultText = "--";

const SidePanel = (props) => {
  const {
    dispatch,
    keplerGl,
    datasetsInfo,
    updateLayerSetting,
    storeStats,
    districtStats,
    analyzeTypes,
    selectedAnalyzeType,
    selectedAttribute,
  } = props;

  const { kglMap } = keplerGl;

  const selectOptions = [
    { value: "", text: selectOptionDefaultText },
    {
      value: analyzeTypes.analyzeStores.value,
      text: analyzeTypes.analyzeStores.text,
    },
    {
      value: analyzeTypes.analyzeDistricts.value,
      text: analyzeTypes.analyzeDistricts.text,
    },
  ];

  const handleChange = (e, { value }) =>
    dispatch(actions.selectAnalyzeType(value));

  const storeAttributesProps = {
    dispatch,
    kglMap,
    datasetsInfo,
    updateLayerSetting,
    storeStats,
    districtStats,
    analyzeTypes,
    selectedAnalyzeType,
    selectedAttribute,
  };

  return (
    <div className="map-panel-wrap">
      <div className="map-panel">
        <Select
          id="analyzeSelect"
          className="map-panel-select"
          placeholder={selectOptionPlaceholderText}
          options={selectOptions}
          onChange={handleChange}
        />
        {selectedAnalyzeType && (
          <div className="map-panel-content">
            <StoreAttributes {...storeAttributesProps} />
          </div>
        )}
      </div>
    </div>
  );
};

/*
        <div className="map-panel-title">Analyze Stores</div>
        <div className="map-panel-content">
          <StoreAttributes {...storeAttributesProps} />
        </div>
 */
/*
 */

SidePanel.defaultProps = {
  data: {},
  keplerGl: {},
  datasetsInfo: {},
  updateLayerSetting: () => {},
};

SidePanel.propTypes = {
  data: PropTypes.object,
  keplerGl: PropTypes.object,
  datasetsInfo: PropTypes.object,
  updateLayerSetting: PropTypes.func,
};

export default SidePanel;
